import { UIKitIcon } from '../icon';

export const searchingIcon: UIKitIcon = {
  name: 'searching',
  // tslint:disable-next-line: max-line-length
  data: '<svg class="svg-icon-searching-animation" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><circle cx="16" cy="16" r="10"/>'
  + '</svg>',
};
